export default {
  // Add to your translation files (create src/i18n/locales/ta/nakshatra.js)

  // Header Section
  "discover_your": "உங்கள்",
  "nakshatra": "நட்சத்திரம்",
  "birth_star_analysis": "பிறந்த நட்சத்திர பகுப்பாய்வு",
  "nakshatra_description": "நட்சத்திரம் என்பது கிரகபாதையில் (ஈக்ளிப்டிக்) அமைந்த 27 சந்திர மாளிகைகளில் ஒன்றாகும்; ஒவ்வொன்றும் நான்கு பதங்களாக (கால்களாக) பிரிக்கப்படுகின்றன. ஒவ்வொரு பதமும் குறிப்பிட்ட எழுத்துக்களுடன் சேர்ந்து இருக்கும்; சந்திரன் இருக்கும் நிலையைக் கொண்டு புதிதாகப் பிறந்த குழந்தைக்குப் பெயர் தேர்வதில் இவ்வெழுத்துகள் பயன்படுத்தப்படுகின்றன.",

  // Service Information
  "enter_birth_details": "உங்கள் பிறப்பு விவரங்களை உள்ளிடுங்கள்",
  "complete_nakshatra_analysis": "முழுமையான நட்சத்திர பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_nakshatra_analysis_note": "உங்கள் பிறந்த நட்சத்திரம் உங்கள் தன்மை, உறவுகள், வாழ்க்கைப் பாதை ஆகியவற்றில் ஏற்படுத்தும் தாக்கத்தை ஆழமாக ஆராய்வு",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_critical_for_nakshatra": "துல்லியமான பிறந்த நேரம் சரியான நட்சத்திரத் தீர்மானத்துக்கு அவசியம்",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் நட்சத்திர பகுப்பாய்வு தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Nakshatra Features
  "birth_star_identification": "பிறந்த நட்சத்திரம் (நட்சத்திரம்) அடையாளம்",
  "personality_traits_detailed": "விரிவான தன்மை & குணாதிசய பகுப்பாய்வு",
  "compatibility_analysis": "திருமணம் & உறவு இணக்கத்தன்மை",
  "career_guidance_nakshatra": "நட்சத்திரத்தின் அடிப்படையில் தொழில் வழிகாட்டுதல்",
  "lucky_elements": "அதிர்ஷ்ட நிறங்கள், எண்கள் & ரத்தினங்கள்",
  "pdf_download": "விரிவான PDF அறிக்கை",

  "what_you_get": "உங்கள் நட்சத்திர பகுப்பாய்வில் உள்ளவை",
  "your_birth_star_detailed": "உங்கள் பிறந்த நட்சத்திரம் (நட்சத்திரம்) — விரிவாக",
  "nakshatra_characteristics": "மூல நட்சத்திர பண்புகள்",
  "pada_analysis": "பத (கால்) பகுப்பாய்வு",
  "ruling_deity_insights": "ஆட்சி தெய்வம் & ஆன்மீக நுண்ணறிவுகள்",

  // Actions & Buttons
  "pay_and_generate_analysis": "என் நட்சத்திர பகுப்பாய்வை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "nakshatra_analysis_processing": "உங்கள் நட்சத்திர பகுப்பாய்வை எங்கள் வேத ஜோதிட நிபுணர்கள் தயாரித்து வருகின்றனர். உங்கள் பிறந்த நட்சத்திரத்தின் தாக்கம் குறித்த ஆழமான நுண்ணறிவுகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_12_hours_delivery_note": "உங்கள் விரிவான நட்சத்திர அறிக்கை 12 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் நட்சத்திர பகுப்பாய்வு தொகுப்பு",
  "detailed_nakshatra_report": "முழுமையான நட்சத்திர அறிக்கை (PDF)",
  "birth_star_characteristics": "பிறந்த நட்சத்திர தன்மை சித்திரம்",
  "pada_and_symbol_analysis": "பத பகுப்பாய்வு & புனிதச் சின்னங்கள்",
  "compatibility_insights": "திருமணம் & கூட்டாண்மை இணக்கம்",
  "lucky_colors_numbers": "அதிர்ஷ்ட கூறுகள் & பரிகார ரத்தினங்கள்",

  // Visual Content
  "sample_nakshatra_analysis": "மாதிரி நட்சத்திர பகுப்பாய்வு",
  "sample_nakshatra_description": "உங்கள் தனிப்பயன் பிறந்த நட்சத்திர பகுப்பாய்வின் முன்னோட்டம் — விரிவான நுண்ணறிவுகளுடன்",
  "popular_nakshatras": "27 நட்சத்திரங்கள்",

  // Major Nakshatra Names
  "ashwini": "அஸ்வினி — குதிரை வீரர்கள்",
  "bharani": "பரணி — சுமப்பவர்",
  "kritika": "கிருத்திகை — வெட்டுபவர்",
  "rohini": "ரோகிணி — சிவந்தவள்",
  "mrigashira": "மிருகசீரிஷம் — மானின் தலை",
  "ardra": "திருவாதிரை — ஈரமுடையவர்",
  "punarvasu": "புனர்பூசம் — மீளப் பூரணிப்பவர்",
  "pushya": "பூசம் — போஷிப்பவர்",
  "ashlesha": "ஆயில்யம் — அலிங்கிப்பவர்",
  "magha": "மகம் — மாபெரும்",
  "purva_phalguni": "பூரம் (பூர்வ பல்குணி)",
  "uttara_phalguni": "உத்திரம் (உத்தர பல்குணி)",

  // Status & Processing
  "your_nakshatra_analysis_status": "உங்கள் நட்சத்திர பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் பிறந்த நட்சத்திரம் ஆய்வு செய்யப்படுகிறது",
  "analysis_processing_message": "உங்கள் நட்சத்திரத்தின் தாரக சக்திகள் மற்றும் தாக்கங்களை எங்கள் வேத ஜோதிட நிபுணர்கள் ஆய்ந்து, தனிப்பயன் நுண்ணறிவுகளைத் தயாரித்து வருகின்றனர்.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_12_hours": "அறிக்கை 12 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "ஜோதிட ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து பிறப்பு விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Nakshatra-Specific Elements
  "birth_star": "பிறந்த நட்சத்திரம்",
  "nakshatra_lord": "நட்சத்திர அதிபதி",
  "ruling_planet": "ஆட்சி கிரகம்",
  "nakshatra_symbol": "புனிதச் சின்னம்",
  "presiding_deity": "அதிபதி தெய்வம்",
  "gana_type": "கண வகை",
  "nakshatra_nature": "இயல்பான தன்மை",
  "power_animal": "சக்தி விலங்கு",

  // Pada (Quarters) Analysis
  "pada_1": "முதல் பத (0°-3°20')",
  "pada_2": "இரண்டாம் பத (3°20'-6°40')",
  "pada_3": "மூன்றாம் பத (6°40'-10°)",
  "pada_4": "நான்காம் பத (10°-13°20')",
  "your_pada": "உங்கள் நட்சத்திர பத",
  "pada_characteristics": "பதத்திற்கு உரிய பண்புகள்",
  "pada_influence": "உங்கள் பத உங்களை எவ்வாறு வடிவமைக்கிறது",

  // Personality & Character
  "core_personality": "மைய தன்மை பண்புகள்",
  "strengths_weaknesses": "வலிமைகள் & வளர்ச்சிப் பகுதிகள்",
  "mental_nature": "மனநிலை இயல்பு",
  "emotional_patterns": "உணர்ச்சி முறைபாடுகள்",
  "behavioral_tendencies": "நடத்தைப் பழக்கங்கள்",
  "life_approach": "வாழ்க்கை அணுகுமுறை",

  // Compatibility & Relationships
  "compatible_nakshatras": "மிகச் சிறந்த இணக்க நட்சத்திரங்கள்",
  "challenging_nakshatras": "சவாலாக இருக்கக் கூடிய பொருத்தங்கள்",
  "marriage_compatibility": "திருமணம் & கூட்டாண்மை பகுப்பாய்வு",
  "friendship_compatibility": "நட்பு இயக்கவியல்",
  "business_partnership": "வணிக கூட்டாண்மை வாய்ப்பு",
  "relationship_advice": "உறவு வழிகாட்டுதல்",

  // Career & Profession
  "suitable_careers": "இயலான தொழில் பாதைகள்",
  "professional_strengths": "தொழில்முறை வலிமைகள்",
  "work_environment": "சிறந்த பணிச்சூழல்",
  "leadership_style": "முன்னணித் தலைமுறை நடை",
  "business_prospects": "தொழில்முனைவு வாய்ப்புகள்",
  "financial_tendencies": "பணம் மேலாண்மை பாணி",

  // Health & Wellness
  "health_tendencies": "ஆரோக்கிய முன்நிலைகள்",
  "vulnerable_areas": "கவனம் தேவைப்படும் பகுதிகள்",
  "wellness_recommendations": "ஆரோக்கிய & நல ஆலோசனைகள்",
  "dietary_guidance": "உணவுக் கட்டுப்பாடு வழிகாட்டுதல்",

  // Spiritual & Remedial
  "spiritual_path": "ஆன்மீகப் பயணம்",
  "life_purpose": "ஆத்துமாவின் நோக்கம்",
  "karmic_lessons": "வாழ்க்கைப் பாடங்கள்",
  "recommended_remedies": "வேத பரிகாரங்கள்",
  "mantras_to_chant": "பயனுள்ள மந்திரங்கள்",
  "meditation_practices": "தியான முறைகள்",
  "worship_recommendations": "தெய்வ வழிபாடு வழிகாட்டுதல்",
  "fasting_days": "சுப உபவாச நாட்கள்",
  "donation_suggestions": "தான தர்ம ஆலோசனைகள்",

  // Lucky Elements
  "lucky_colors": "அதிர்ஷ்ட நிறங்கள்",
  "lucky_numbers": "அதிர்ஷ்ட எண்கள்",
  "lucky_days": "சிறந்த வார நாட்கள்",
  "lucky_directions": "அதிர்ஷ்ட திசைகள்",
  "lucky_gemstones": "ஆசியளிக்கும் ரத்தினங்கள்",
  "lucky_metals": "அதிர்ஷ்ட உலோகங்கள்",
  "favorable_timing": "முக்கிய செயல்களுக்கு உகந்த நேரம்",

  // Detailed Analysis Sections
  "nakshatra_mythology": "புராணப் பின்னணி",
  "cosmic_connection": "அண்டத் தொடர்பு",
  "elemental_influence": "மூலக்கூறு தொடர்புகள்",
  "seasonal_connection": "஋துக்களுடன் உள்ள தொடர்பு",
  "lunar_mansion": "சந்திர மாளிகை முக்கியத்துவம்",
  "vedic_wisdom": "பண்டைய வேத நுண்ணறிவுகள்"
};
